module.exports = __webpack_public_path__ + "img/1078_2.f7d52b5c.jpg";